/* BiduCollectibles v2 - motion + interaction engine.
   No dependencies. Everything degrades: without this file the pages are fully
   readable and every link and form still works (the CSS has a 3s failsafe). */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------- split headlines into masked words ---------- */
  function split(el) {
    if (!once(el, 'bSplit')) return;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = d.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(d.createTextNode(' ')); return; }
            var w = d.createElement('span'); w.className = 'w';
            var s = d.createElement('span'); s.textContent = t; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
      });
    })(el);
    el.classList.add('is-split');
  }

  /* ---------- reveal on scroll ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.hasAttribute('data-count')) countUp(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }) : null;

  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-count')) || 0;
    var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
    if (reduce) { el.textContent = pre + to + suf; return; }
    var t0 = performance.now(), dur = 1600;
    (function tick(now) {
      var p = clamp((now - t0) / dur, 0, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + Math.round(to * e) + suf;
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }

  /* ---------- pointer effects ---------- */
  function tilt(el) {
    if (!fine || reduce || !once(el, 'bTilt')) return;
    var max = parseFloat(el.getAttribute('data-tilt')) || 10, raf = 0;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        el.style.setProperty('--rx', ((0.5 - y) * max).toFixed(2) + 'deg');
        el.style.setProperty('--ry', ((x - 0.5) * max).toFixed(2) + 'deg');
        el.style.setProperty('--px', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--py', (y * 100).toFixed(1) + '%');
        el.classList.add('is-tilting');
      });
    });
    el.addEventListener('pointerleave', function () {
      cancelAnimationFrame(raf);
      el.classList.remove('is-tilting');
      el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg');
    });
  }

  function magnetic(el) {
    if (!fine || reduce || !once(el, 'bMag')) return;
    var k = parseFloat(el.getAttribute('data-magnetic')) || 0.3;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', ((e.clientX - r.left - r.width / 2) * k).toFixed(1) + 'px');
      el.style.setProperty('--my', ((e.clientY - r.top - r.height / 2) * k).toFixed(1) + 'px');
    });
    el.addEventListener('pointerleave', function () { el.style.setProperty('--mx', '0px'); el.style.setProperty('--my', '0px'); });
  }

  function spotlight(el) {
    if (!fine || !once(el, 'bSpot')) return;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--sx', (e.clientX - r.left) + 'px');
      el.style.setProperty('--sy', (e.clientY - r.top) + 'px');
    });
  }

  /* hero layers drift toward the pointer */
  function follow(el) {
    if (!fine || reduce || !once(el, 'bFollow')) return;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--fx', (((e.clientX - r.left) / r.width - 0.5) * 2).toFixed(3));
      el.style.setProperty('--fy', (((e.clientY - r.top) / r.height - 0.5) * 2).toFixed(3));
    });
    el.addEventListener('pointerleave', function () { el.style.setProperty('--fx', 0); el.style.setProperty('--fy', 0); });
  }

  /* ---------- scroll: progress, nav state, parallax, velocity skew ----------
     Horizon scrolls .page-wrapper rather than the window, so read from
     whichever element actually scrolls. */
  var scroller = (function () {
    var pw = d.querySelector('.page-wrapper');
    if (pw) { var o = getComputedStyle(pw).overflowY; if (o === 'auto' || o === 'scroll') return pw; }
    return null;
  })();
  function scrollTop() { return scroller ? scroller.scrollTop : window.scrollY; }
  function scrollMax() { return scroller ? scroller.scrollHeight - scroller.clientHeight : root.scrollHeight - innerHeight; }
  var par = [], lastY = scrollTop(), vel = 0, looping = false, hidden = false;
  function frame() {
    var y = scrollTop(), h = scrollMax();
    root.style.setProperty('--b-progress', h > 0 ? (y / h).toFixed(4) : 0);
    d.body.classList.toggle('b-scrolled', y > 40);
    var dy = y - lastY;
    if (y > 420 && dy > 6 && !d.body.classList.contains('b-menu-open')) hidden = true;
    else if (dy < -6 || y < 200) hidden = false;
    d.body.classList.toggle('b-nav-hidden', hidden);
    vel = vel * 0.82 + dy * 0.18; lastY = y;
    if (!reduce) {
      root.style.setProperty('--b-skew', clamp(vel * 0.2, -7, 7).toFixed(2) + 'deg');
      for (var i = 0; i < par.length; i++) {
        var r = par[i].getBoundingClientRect();
        if (r.bottom < -200 || r.top > innerHeight + 200) continue;
        var c = r.top + r.height / 2 - innerHeight / 2;
        par[i].style.setProperty('--shift', (-c * (parseFloat(par[i].getAttribute('data-parallax')) || 0.15)).toFixed(1) + 'px');
      }
    }
    if (Math.abs(vel) > 0.05) requestAnimationFrame(frame); else { looping = false; root.style.setProperty('--b-skew', '0deg'); }
  }
  function onScroll() { if (!looping) { looping = true; requestAnimationFrame(frame); } }

  /* ---------- header: sliding blob, mobile menu, search ---------- */
  function nav() {
    var list = d.querySelector('.b-nav__links');
    if (list && once(list, 'bNav')) {
      var blob = list.querySelector('.b-nav__blob');
      var links = $$('.b-nav__link', list);
      var active = list.querySelector('.b-nav__link[aria-current]');
      var move = function (a) {
        links.forEach(function (l) { l.classList.toggle('is-hot', l === a); });
        if (!a || !blob) { if (blob) blob.style.opacity = 0; return; }
        var lr = list.getBoundingClientRect(), ar = a.getBoundingClientRect();
        blob.style.width = ar.width + 'px';
        blob.style.transform = 'translateX(' + (ar.left - lr.left) + 'px)';
        blob.style.opacity = 1;
      };
      links.forEach(function (a) {
        a.addEventListener('mouseenter', function () { move(a); });
        a.addEventListener('focus', function () { move(a); });
      });
      list.addEventListener('mouseleave', function () { move(active); });
      setTimeout(function () { move(active); }, 120);
      addEventListener('resize', function () { move(active); });
    }
    $$('[data-menu-toggle]').forEach(function (btn) {
      if (!once(btn, 'bMenu')) return;
      btn.addEventListener('click', function () {
        var open = !d.body.classList.contains('b-menu-open');
        d.body.classList.toggle('b-menu-open', open);
        $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
        var m = d.getElementById('b-menu');
        if (m) m.setAttribute('aria-hidden', !open);
        if (open && m) { var f = m.querySelector('a, button'); if (f) setTimeout(function () { f.focus(); }, 300); }
      });
    });
    $$('[data-search-open]').forEach(function (a) {
      if (!once(a, 'bSearch')) return;
      a.addEventListener('click', function (e) {
        var m = d.getElementById('search-modal');
        if (m && typeof m.showDialog === 'function') { e.preventDefault(); m.showDialog(); }
      });
    });
  }
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && d.body.classList.contains('b-menu-open')) {
      var t = d.querySelector('[data-menu-toggle]'); if (t) t.click();
    }
  });

  /* ---------- rails: buttons + drag ---------- */
  function rail(el) {
    if (!once(el, 'bRail')) return;
    var sc = el.querySelector('.b-rail__scroller'); if (!sc) return;
    $$('[data-rail-prev],[data-rail-next]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        sc.scrollBy({ left: (b.hasAttribute('data-rail-next') ? 1 : -1) * sc.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if (!fine) return;
    var down = false, sx = 0, sl = 0, moved = 0;
    sc.addEventListener('pointerdown', function (e) { if (e.button !== 0) return; down = true; moved = 0; sx = e.clientX; sl = sc.scrollLeft; });
    addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
      if (moved > 6) { sc.classList.add('is-dragging'); sc.scrollLeft = sl - dx; }
    });
    addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { sc.classList.remove('is-dragging'); }, 0); });
    sc.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    sc.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- boot ---------- */
  function init() {
    $$('[data-split]').forEach(split);
    $$('[data-stagger]').forEach(function (g) { Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); }); });
    $$('[data-reveal],[data-split],[data-count]').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
    $$('[data-tilt]').forEach(tilt);
    $$('[data-magnetic]').forEach(magnetic);
    $$('[data-spotlight]').forEach(spotlight);
    $$('[data-follow]').forEach(follow);
    $$('[data-rail]').forEach(rail);
    par = $$('[data-parallax]');
    nav(); onScroll();
    root.classList.add('b-ready');
  }
  (scroller || window).addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
})();